import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { ResponsibleOfficialService } from 'brain-data/service/responsible-official/responsible-official.service';
import {
  createResponsibleOfficial,
  createResponsibleOfficialError,
  createResponsibleOfficialSuccess,
  deleteResponsibleOfficial,
  deleteResponsibleOfficialError,
  deleteResponsibleOfficialSuccess,
  loadResponsibleOfficials,
  loadResponsibleOfficialsError,
  loadResponsibleOfficialsSuccess,
  updateResponsibleOfficial,
  updateResponsibleOfficialError,
  updateResponsibleOfficialSuccess,
} from '../actions/responsible-official.action';

@Injectable()
export class ResponsibleOfficialEffects {
  loadResponsibleOfficials$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadResponsibleOfficials),
      switchMap(() =>
        this.service.getAll().pipe(
          map(officials => loadResponsibleOfficialsSuccess({ officials })),
          catchError((error: Error) => of(loadResponsibleOfficialsError({ error }))),
        ),
      ),
    ),
  );

  createResponsibleOfficial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createResponsibleOfficial),
      switchMap(({ payload }) =>
        this.service.create(payload).pipe(
          map(official => createResponsibleOfficialSuccess({ official })),
          catchError((error: Error) => of(createResponsibleOfficialError({ error }))),
        ),
      ),
    ),
  );

  updateResponsibleOfficial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateResponsibleOfficial),
      switchMap(({ id, payload }) =>
        this.service.update(id, payload).pipe(
          map(official => updateResponsibleOfficialSuccess({ official })),
          catchError((error: Error) => of(updateResponsibleOfficialError({ error }))),
        ),
      ),
    ),
  );

  deleteResponsibleOfficial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteResponsibleOfficial),
      switchMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => deleteResponsibleOfficialSuccess({ id })),
          catchError((error: Error) => of(deleteResponsibleOfficialError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: ResponsibleOfficialService,
  ) {}
}
